import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  branch,
  branchByIdResponse,
  branchResponse,
} from "@/interface/branch.interface";

export const BranchService = {
  createBranch: async (payload: branch): Promise<branchResponse> => {
    const API = `${API_ENDPOINT.Branch}`;
    return callApi<branchResponse>(API, { method: "POST", data: payload });
  },

  getBranch: async (params?: string): Promise<branchResponse> => {
    const API = `${API_ENDPOINT?.Branch}${params ? `?${params}` : ""}`;
    return callApi<branchResponse>(API, { method: "GET" });
  },

  updateBranch: async (
    id: string,
    payload: branch,
  ): Promise<branchResponse> => {
    const API = `${API_ENDPOINT?.Branch}/${id}`;
    return callApi<branchResponse>(API, { method: "PUT", data: payload });
  },

  deleteBranch: async (id: string): Promise<branchResponse> => {
    const API = `${API_ENDPOINT?.Branch}/${id}`;
    return callApi<branchResponse>(API, { method: "DELETE" });
  },

  getBranchById: async (id: string): Promise<branchByIdResponse> => {
    const API = `${API_ENDPOINT?.Branch}/${id}`;
    return callApi<branchByIdResponse>(API, { method: "GET" });
  },
};
